import { defineMessages } from 'react-intl-next';

export const messages: {
	ai_answer_card_collapse_button: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_answer_card_expand_button: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_answer_card_tab_ai_answer: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_answer_card_tab_sources: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_answer_card_tab_sources_with_pluralization: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_answer_card_read_more_button: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_answer_card_show_more_button: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_answer_open_chat_input_box_ask_rovo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_answer_card_early_stop_text: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ai_answer_card_early_stop_close_button_label: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	ai_answer_card_collapse_button: {
		id: 'search_ai.ai_answer_card_collapse_button',
		defaultMessage: 'Collapse',
		description: 'Text for the smart answer card "Collapse" button',
	},
	ai_answer_card_expand_button: {
		id: 'search_ai.ai_answer_card_expand_button',
		defaultMessage: 'Expand',
		description: 'Text for the smart answer card "Expand" button',
	},
	ai_answer_card_tab_ai_answer: {
		id: 'search_ai.ai_answer_card_tab_ai_answer',
		defaultMessage: 'AI Answer',
		description: 'Text for the smart answer card "AI answer" tab',
	},
	ai_answer_card_tab_sources: {
		id: 'search_ai.ai_answer_card_tab_sources',
		defaultMessage: 'Sources',
		description: 'Text for the smart answer card "Sources" tab',
	},
	ai_answer_card_tab_sources_with_pluralization: {
		id: 'search_ai.ai_answer_card_tab_sources_with_pluralization',
		defaultMessage: '{sourcesCount, plural, one {Source} other {Sources {sourcesCount}}}',
		description: 'Text for the smart answer card "Sources" tab with pluralization',
	},
	ai_answer_card_read_more_button: {
		id: 'search_ai.ai_answer_card_read_more_button',
		defaultMessage: 'Read more',
		description: 'Text for the smart answer card "Read more" button',
	},
	ai_answer_card_show_more_button: {
		id: 'search_ai.ai_answer_card_show_more_button',
		defaultMessage: 'Show more',
		description: 'Text for the smart answer card "Show more" button',
	},
	ai_answer_open_chat_input_box_ask_rovo: {
		id: 'search_ai.ai_answer_open_chat_input_box_ask_rovo',
		defaultMessage: 'Ask Rovo anything',
		description: 'Placeholder text for input box',
	},
	ai_answer_card_early_stop_text: {
		id: 'search_ai.ai_answer_card_early_stop_text',
		defaultMessage:
			'Rovo couldn\'t generate an answer for "{searchQuery}". Try rephrasing your query.',
		description: 'Text for early stop streaming response card',
	},
	ai_answer_card_early_stop_close_button_label: {
		id: 'search_ai.ai_answer_card_early_stop_close_button',
		defaultMessage: 'Close',
		description: 'Label for the close button on the early stop card',
	},
});
